module.exports = __webpack_public_path__ + "static/media/shean_bg.dbd575d9.png";